import { SearchRequestInstrumentation } from 'owa-search-service';
import { PerformanceDatapoint, CalculatedResourceTimings } from 'owa-analytics';
import { mutatorAction } from 'satcheljs';

export default mutatorAction(
    'addResourceTimingEntryMutator',
    function addResourceTimingEntryMutator(
        searchInstrumentationEntry: SearchRequestInstrumentation,
        resourceTimingEntry: CalculatedResourceTimings,
        executeSearchDatapoint: PerformanceDatapoint
    ) {
        searchInstrumentationEntry.ResourceTimingEntry = resourceTimingEntry;

        // The end to end datapoint only exists for page 0 requests
        if (executeSearchDatapoint) {
            searchInstrumentationEntry.ClientJSEndToEndTime =
                executeSearchDatapoint.waterfallTimings['ClientJSEndToEndTime'];
        }
    }
);
